export const getStockStatus = (quantity, etaValue = '') => {
    if (quantity > 12) {
        return 'available'; // Available - vert
    } else if (quantity >= 6) {
        return 'low-availability'; // Low availability - vert
    } else if (quantity >= 1) {
        return 'last-pieces'; // Last pieces - orange
    } else {
        // Si pas de stock, vérifier s'il y a un ETA
        return etaValue && etaValue.trim() !== '' ? 'coming-soon' : 'not-available';
    }
};

export const formatStockMessage = (stockLevel, etaValue = '') => {
    if (stockLevel === 0) {
        // Si pas de stock, vérifier s'il y a un ETA
        return etaValue && etaValue.trim() !== '' ? 'COMING SOON' : 'NOT AVAILABLE';
    }
    if (stockLevel > 0 && stockLevel <= 3) {
        return 'LATEST PIECES';
    }
    if (stockLevel > 3 && stockLevel <= 12) {
        return 'LOW AVAILABILITY';
    }
    // Pour stock > 12, on affiche "AVAILABLE"
    return 'AVAILABLE';
};

export const isDiscontinued = (isDiscontinuedValue = false) => {
    return isDiscontinuedValue === true || isDiscontinuedValue === 'true';
};